<template>
	<div class="cw-customer-service">
		客服服务
  	</div>
</template>

<script>

export default {

	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

	mounted() {

	},

	methods: {

	}
}
</script>

<style lang="scss" scoped>
.cw-customer-service {
    padding-top: 104px;
    font-size: 12px;
}
</style>

